/**
 * Determines if a hex color code is a light color on a white background
 * @param color - hex color code
 * @returns bolean - true if color is light enough to not be easily visible, false otherwise
 */
export const isLightColour = (color: string): boolean => {
    const hex = color.replace("#", "");
    let r: number;
    let g: number;
    let b: number;

    if (hex.length === 3) {
        r = parseInt(hex[0] + hex[0], 16);
        g = parseInt(hex[1] + hex[1], 16);
        b = parseInt(hex[2] + hex[2], 16);
    } else if (hex.length === 6) {
        r = parseInt(hex.substring(0, 2), 16);
        g = parseInt(hex.substring(2, 4), 16);
        b = parseInt(hex.substring(4, 6), 16);
    } else {
        // fallback for non-hex
        return false;
    }

    return r > 220 && g > 220 && b > 220;
};
